import { createContext, useContext } from "react";

type FeatureFlagProviderProps<T> = {
  value: T;
  children: React.ReactNode;
};

export const createFeatureFlagContext = <T extends Record<string, boolean>>() => {
  const Context = createContext<T | undefined>(undefined);

  const Provider: React.FC<FeatureFlagProviderProps<T>> = ({ value, children }) => (
    <Context.Provider value={value}>{children}</Context.Provider>
  );

  const useFeatureFlags = (): T => {
    const context = useContext(Context);
    if (!context) {
      throw new Error("useFeatureFlags must be used within a FeatureFlagProvider");
    }
    return context;
  };

  return {
    Provider,
    useFeatureFlags,
  };
};
